import * as React from 'react'
import * as ReactDOM from 'react-dom/client'

// Plume theme tokens (soft/contrast) then the shared page base reset — the only global CSS on the page.
import '@ulule/owl-kit-components/src/constants/css/themes.css'
import '@ulule/owl-kit-components/src/constants/css/colors.css'
import '../_shared/base.css'

// The social-card image is referenced only from the prerendered <head> (og:image, built by the
// SSR-only metadata module). Import it here so it enters the client bundle graph and Vite emits the
// hashed file that <meta og:image> points at — otherwise nothing emits it and the URL 404s.
import './assets/og/og.png?url'

import { App } from './App'
import { bootstrap } from '../_shared/bootstrap'
import { mountHeaderAndFooter } from '../_shared/chrome'
import { readPrerenderedStats } from '../_shared/ululeStats'
import { readPrerenderedCollections } from './collections'

void main()

async function main(): Promise<void> {
  // Hydrate the pre-rendered main content immediately — it needs no env/user data.
  const statsRoot = document.getElementById('stats-root')
  if (statsRoot !== null) {
    ReactDOM.hydrateRoot(
      statsRoot,
      <App initialStats={readPrerenderedStats()} collections={readPrerenderedCollections()} />,
    )
  }

  // Then bootstrap env/locale and mount the reused site chrome (client-only, like every MPA page).
  const userConfig = await bootstrap()
  mountHeaderAndFooter(userConfig)
}
